module.exports = __webpack_public_path__ + "media/site_templates/www.guttercleaning.biz/images/our_services_1-c67f59b06a0f3dc8a120c50d4dbcf5fd.jpg";